/**
 * Which of the two menus a URL belongs to.
 *
 * Its own module, and deliberately dependency-free, because three things need
 * this vocabulary and they cannot all import each other: `OrgContext` derives
 * the level, `routesUtil/detailRoutes` maps a level to a detail route, and the
 * menu hooks gate their entries on it. With the type living in the context, the
 * route map had to import the context and the context had to import the map.
 *
 * Do not add anything here that reads the URL, the store or React. This is the
 * vocabulary, not the derivation — `OrgContext` owns that.
 */
export const MenuLevelConst = {
  /** The own-level menu: the login's own organisation and its own artifacts. */
  OWN: "own",
  /** The cross-level menu: every org the user can see, or one of them sliced. */
  CROSS: "cross",
} as const;

export type MenuLevel = (typeof MenuLevelConst)[keyof typeof MenuLevelConst];
